import axios from 'axios'

const namespaced = true

const state = {
  houseShipments: null,
  visible: false,
  portals: null,
  statuses: null,
  definitePackage: null,
  documents: null,
  loading: false,
  pages: null,
  pids: null,
  declineReasons: null,
  packagePid: null,
  packageChainid: null,
  packageStatus: null,
  package: null,
  nsiCurrency: null,
  nsiIdentityDocuments: null,
  nsiAirports: null,
  packageDocumentsList: null,
  waybill: null,
  freeBinaryDocs: [],
  passport: null,
  airWaybill: null,
}
const actions = {
  getHouseShipments({ commit }, data) {
    const params = new URLSearchParams(data.queryParams)
    let keysForDel = [];
    params.forEach((value, key) => {
      if (value == '') {
          keysForDel.push(key)
      }
    })
    keysForDel.forEach(key => {
        params.delete(key)
    })
    const url = `/api/private/v5.0/houseshipments/${data.portalId}/packages/?`
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: url + params.toString()
      })
      .then(response => {
        commit('setHouseShipments', response.data)
        commit('setVisible', false)
        resolve()
      })
      .catch(error => {
          commit('setVisible', false)
          reject(error)
      })
    })
  },
  getEcrHouseShipments ({ commit }, data) {
    const url = `/api/private/v5.0/ecr/${data.portalId}/packages/${data.pid}/?`
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: url + `per_page=10&page=${data.page}`
      })
        .then(response => {
          commit('setEcrHouseShipments', response.data)
          commit('setVisible', false)
          resolve()
        })
        .catch(error => {
          commit('setVisible', false)
          reject(error)
        })
    })
  },
  sendEmail (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `/api/private/v5.0/house-shipment/send-mail/`,
        data: data
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createHouseShipment ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v5.0/house-shipment/',
        data
      })
        .then(response => {
          commit('setPackagePid', response.data.pid)
          resolve({ did: response.data.document.did })
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editHouseShipment (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: '/api/private/v5.0/house-shipment/',
        data
      })
      .then(() => {
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  getPackageByPid ({ commit }, data) {
    commit('setPackage', null)
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/house-shipment/${data.pid}/`
      })
        .then(response => {
          commit('setPackage', { data: response.data, new: data.new })
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiCurrency ({ commit }, data) {
    let settings = {
      method: 'GET',
      url: `${process.env.VUE_APP_NSI_HOST}nsi/currency`
    }
    if (data && data.p && (data.p.length > 0)) {
      settings = Object.assign(settings, { params: data })
    }
    return new Promise((resolve, reject) => {
      axios(settings)
        .then(response => {
          commit('setNsiCurrency', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiIdentityDocuments ({ commit }, data) {
    let settings = {
      method: 'GET',
      url: `${process.env.VUE_APP_NSI_HOST}nsi/documents`
    }
    if (data && data.p && (data.p.length > 0)) {
      settings = Object.assign(settings, { params: data })
    }
    return new Promise((resolve, reject) => {
      axios(settings)
        .then(response => {
          commit('setNsiIdentityDocuments', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadNsiAirports ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/nsi/airports',
        params: data
      })
        .then(response => {
          commit('setNsiAirports', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPackageDocumentsList ({ commit }, data) {
    commit('setPackageDocumentsList', null)
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/packages/${data}/`
      })
      .then(response => {
        commit('setPackageDocumentsList', response.data.documents)
        commit('setPackagePid', response.data.pid)
        commit('setPackageChainid', response.data.chainid)
        commit('setPackageStatus', response.data.status)
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  getWaybillByPid ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/house-shipment/individual-waybill/${data.pid}/`
      })
        .then(response => {
          commit('setWaybill', { data: response.data, new: data.new })
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createWaybill ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v5.0/house-shipment/individual-waybill/',
        data
      })
        .then(response => {
          commit('setPackagePid', response.data.pid)
          resolve({ did: response.data.document.did })
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editWaybill (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: '/api/private/v5.0/house-shipment/individual-waybill/',
        data
      })
      .then(() => {
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  deleteWaybill (_, data) {
    const payload = {
      pid: data.pid,
      did: data.did
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'DELETE',
        url: '/api/private/v5.0/house-shipment/individual-waybill/',
        params: payload
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  sendPackageFts (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `/api/private/v5.0/packages/send/${data}/`
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getFreeBinaryDoc ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/house-shipment/free-binary-doc/`,
        params: {
          pid: data.pid,
          did: data.did
        }
      })
        .then(response => {
          commit('setFreeBinaryDoc', { data: response.data, new: data.new })
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  downloadFreeBinaryDocData (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v5.0/free-binary-doc/',
        params: {
          pid: data.pid,
          did: data.did
        }
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteFreeBinaryDoc (_, data) {
    const payload = {
      pid: data.pid,
      did: data.did
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'DELETE',
        url: '/api/private/v5.0/free-binary-doc/',
        params: payload
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createFreeBinaryDoc ({ commit }, data) {
    const payload = {
      pid: data.pid,
      did: data.did,
      chainid: data.chainid,
      data: data.data
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v5.0/free-binary-doc/',
        data: payload
      })
        .then(response => {
          commit('setPackagePid', response.data)
          resolve({ did: response.data.document.did })
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editFreeBinaryDoc (_, data) {
    const payload = {
      pid: data.pid,
      did: data.did,
      chainid: data.chainid,
      data: data.data
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: '/api/private/v5.0/free-binary-doc/',
        data: payload
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadPackageDocuments ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/portals/${data.portalId}/packages/${data.package}/documents/`
      })
        .then(response => {
          commit('setPackageDocuments', response.data)
          commit('setVisible', false)
          resolve()
        })
        .catch(error => {
          commit('setVisible', false)
          reject(error)
        })
    })
  },
  getPassportByPid ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/ecr/passport/${data.pid}/`
      })
      .then(response => {
        commit('setPassport', { data: response.data, new: data.new })
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  createPassport ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v5.0/ecr/passport/',
        data
      })
        .then(response => {
          commit('setPackagePid', response.data.pid)
          resolve({ did: response.data.document.did })
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editPassport (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: '/api/private/v5.0/ecr/passport/',
        data
      })
      .then(() => {
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  deletePassport (_, data) {
    const payload = {
      pid: data.pid,
      did: data.did
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'DELETE',
        url: '/api/private/v5.0/ecr/passport/',
        params: payload
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAirWaybillByPid ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v5.0/ecr/air-waybill/${data.pid}/`
      })
      .then(response => {
        commit('setAirWaybill', { data: response.data, new: data.new })
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  createAirWaybill ({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v5.0/ecr/air-waybill/',
        data
      })
        .then(response => {
          commit('setPackagePid', response.data.pid)
          resolve({ did: response.data.document.did })
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editAirWaybill (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: '/api/private/v5.0/ecr/air-waybill/',
        data
      })
      .then(() => {
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  deletetAirWaybill (_, data) {
    const payload = {
      pid: data.pid,
      did: data.did
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'DELETE',
        url: '/api/private/v5.0/ecr/air-waybill/',
        params: payload
      })
        .then(() => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}

const mutations = {
  setHouseShipments (state, data) {
    for (let i = 0; i < data.packages.length; i++) {
        data.packages[i].documents = null
        data.packages[i].actions = { visible: false }
        data.packages[i].index = i.toString()
        data.packages[i].waybill = data.packages[i].info[1]
        data.packages[i].vehicle = data.packages[i].info[4]
        data.packages[i].manifest = { id: null, progress: false }
    }
    state.houseShipments = data.packages.filter((p) => {
        return p.status !== 107
    })
    if (data.pages) {
        state.pages = data.pages
    }
    if (data.pids) {
        state.pids = data.pids
    }
  },
  setVisible(state, value) {
    state.visible = value
  },
  setEcrHouseShipments (state, data) {
    for (let i = 0; i < data.packages[0].houseshipments.data.length; i++) {
      data.packages[0].houseshipments.data[i].documents = null
      data.packages[0].houseshipments.data[i].actions = { visible: false }
      data.packages[0].houseshipments.data[i].index = i.toString()
      data.packages[0].houseshipments.data[i].waybill = data.packages[0].houseshipments.data[i].info[1]
      data.packages[0].houseshipments.data[i].vehicle = data.packages[0].houseshipments.data[i].info[4]
      data.packages[0].houseshipments.data[i].manifest = { id: null, progress: false }
    }
    state.houseShipments = data.packages[0].houseshipments.data.filter((p) => {
      return p.status !== 107
    })
    if (data.packages[0].houseshipments.pages) {
      state.pages = data.packages[0].houseshipments.pages
    }
  },
  clearEcrHouseShipments (state) {
    state.houseShipments = null
    state.pages = null
  },
  setPackagePid (state, value) {
    state.packagePid = value
  },
  setPackageChainid (state, value) {
    state.packageChainid = value
  },
  setPackageStatus (state, value) {
    state.packageStatus = value
  },
  setPackage (state, value) {
    const isNewPackageInChain = [4, 730, 731, 754, 0, 6].find((item) => {
      return item === parseInt(state.packageStatus)
    })
    if (value) {
      if ((!!isNewPackageInChain === true) || value.new) {
        if (value.data) value.data.did = null
      }
      state.package = value.data
    } else {
      state.package = value
    }
  },
  setNsiCurrency (state, value) {
    state.nsiCurrency = value
  },
  setNsiIdentityDocuments (state, value) {
    state.nsiIdentityDocuments = value
  },
  setNsiAirports (state, value) {
    state.nsiAirports = value
  },
  setPackageDocumentsList (state, value) {
    state.packageDocumentsList = value
  },
  setWaybill (state, value) {
    const isNewPackageInChain = [4, 730, 731, 754, 0, 6].find((item) => {
      return item === parseInt(state.packageStatus)
    })
    if (value) {
      if ((!!isNewPackageInChain === true) || value.new) {
        if (value) value.data.did = null
      }
      state.waybill = value.data
    }
    else {
      state.waybill = value
    }
  },
  setFreeBinaryDoc (state, value) {
    const isNewPackageInChain = [4, 730, 731, 754, 0, 6].find((item) => {
      return item === parseInt(state.packageStatus)
    })
    if (value) {
      let data = state.freeBinaryDocs.find((item) => {
        return parseInt(item.did) === parseInt(value.data.did)
      })
      const did = ((!!isNewPackageInChain === true) || value.new) ? null : value.data.did
      if (data) data = { did, ...value.data.data }
      else state.freeBinaryDocs.push({ did, ...value.data.data })
    }
  },
  setFreeBinaryDocs (state, value) {
    state.freeBinaryDocs = []
    if (value) {
      state.freeBinaryDocs = value
    }
  },
  setPackageDocuments (state, data) {
    state.documents = data
  },
  setPassport (state, value) {
    const isNewPackageInChain = [4, 730, 731, 754, 0, 6].find((item) => {
      return item === parseInt(state.packageStatus)
    })
    if (value) {
      if ((!!isNewPackageInChain === true) || value.new) {
        if (value) value.data.did = null
      }
      state.passport = value.data
    }
    else {
      state.passport = value
    }
  },
  setAirWaybill (state, value) {
    const isNewPackageInChain = [4, 730, 731, 754, 0, 6].find((item) => {
      return item === parseInt(state.packageStatus)
    })
    if (value) {
      if ((!!isNewPackageInChain === true) || value.new) {
        if (value) value.data.did = null
      }
      state.airWaybill = value.data
    }
    else {
      state.airWaybill = value
    }
  },
}
const getters = {
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
